import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { toggleSelectedStatVisibility } from 'store/selectedStats/actions';

import SelectedColumnComponent from './Component';

class SelectedColumnContainer extends React.PureComponent {
  constructor (props) {
    super(props);

    this.handleVisibilityCheckboxChange = () => {
      this.props.toggleSelectedStatVisibility(this.props.name);
    };
  }

  render () {
    return (
      <SelectedColumnComponent
        name={this.props.name}
        type={this.props.targetType}
        isVisible={this.props.isVisible}
        filterType={this.props.filterType}
        filterOptions={this.props.filterOptions}

        onVisibilityCheckboxChange={this.handleVisibilityCheckboxChange}
      />
    );
  }
}

SelectedColumnContainer.propTypes = {
  name: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  targetType: PropTypes.string.isRequired,

  filterType: PropTypes.string,
  filterOptions: PropTypes.object,

  toggleSelectedStatVisibility: PropTypes.func.isRequired
};

SelectedColumnContainer.defaultProps = {
  filterType: null,
  filterOptions: null
};

const mapDispatchToProps = {
  toggleSelectedStatVisibility
};

export default connect(null, mapDispatchToProps)(
  SelectedColumnContainer
);
